import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import ProgressionApp from './ProgressionApp';

// Determine which app to load based on environment variable
const isProgressionMode = process.env.REACT_APP_MODE === 'progression';
const AppComponent = isProgressionMode ? ProgressionApp : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppComponent />
  </React.StrictMode>
);